export enum TaxRateRoles {
  VIEWER = 'roles.taxRatesViewer',
  PERSISTER = 'roles.taxRatesPersister',
  DELETER = 'roles.taxRatesDeleter',
}
